import { render } from "./VentasFacturasView.vue?vue&type=template&id=0ea75775&scoped=true"
import script from "./VentasFacturasView.vue?vue&type=script&lang=js"
export * from "./VentasFacturasView.vue?vue&type=script&lang=js"

import "./VentasFacturasView.vue?vue&type=style&index=0&id=0ea75775&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea75775"]])

export default __exports__